import { render, staticRenderFns } from "./Discussions.vue?vue&type=template&id=3ed27e7b&"
import script from "./Discussions.vue?vue&type=script&lang=js&"
export * from "./Discussions.vue?vue&type=script&lang=js&"
import style0 from "./Discussions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports